import React from "react";
import Column from "../Column";
import Row from "../Row";
import Title from "../Title";
import { InputProps } from "antd";
import Input, { PasswordProps, TextAreaProps } from "antd/es/input";

export type InputTextType = {
  TEXT: InputProps;
  PASSWORD: PasswordProps;
  MULTI_LINE: TextAreaProps;
};

interface AppInputTextProps<KEY extends keyof InputTextType> {
  label?: React.ReactNode;
  onTextChange?: (text: string) => void;
  orientation?: "col" | "row";
  errorText?: string;
  isRequired?: boolean;
  currentValue?: string | null;
  textType?: KEY;
  additionProps?: InputTextType[KEY];
}

function AppInputText<TYPE extends keyof InputTextType>(props: AppInputTextProps<TYPE>) {
  const {
    currentValue,
    label,
    isRequired,
    onTextChange,
    errorText,
    textType,
    orientation = 'row'
  } = props;

  function renderTextInput() {
    switch (textType) {
      case "MULTI_LINE": {
        const rest = props.additionProps as TextAreaProps;
        return (
          <Input.TextArea
            className={`w-100 `}
            status={!!errorText ? "error" : ""}
            onChange={(e) => onTextChange?.(e.target.value)}
            rows={3}
            value={currentValue ?? undefined}
            // maxLength={maxLength ?? DEFAULT_MAX_LENGTH_TEXT}
            {...rest}
          />
        );
      }

      case "PASSWORD": {
        const rest = props.additionProps as PasswordProps;
        return (
          <Input.Password
            status={!!errorText ? "error" : ""}
            onChange={(e) => onTextChange?.(e.target.value)}
            value={currentValue || ""}
            {...rest}
          />
        );
      }

      default: {
        const rest = props.additionProps as InputProps;
        return (
          <Input
            className={`w-100`}
            status={!!errorText ? "error" : ""}
            onChange={(e) => onTextChange?.(e.target.value)}
            value={currentValue ?? undefined}
            {...rest}
          />
        );
      }
    }
  }

  return (
    <Column className="w-100">
      {orientation === 'col' ? (
        <Column className="gap-1">
          {label && (
            <Title
              label={label}
              isRequired={isRequired}
              vertical
              disabled={props.additionProps?.disabled}
            />
          )}

          <>{renderTextInput()}</>
        </Column>
      ) : (
        <Row>
          {label && (
            <Title label={label} isRequired={isRequired} disabled={props.additionProps?.disabled} />
          )}

          <>{renderTextInput()}</>
        </Row>
      )}

      {errorText && (
        <small className={`text-error pb-1`} style={orientation === 'col' ? {} : { marginLeft: 120 }}>
          {errorText}
        </small>
      )}
    </Column>
  );
}

export default AppInputText;
